import { Observable } from "rxjs";
import { PartsLinkAccessRequest } from "../../model/parts-links-access.model";

export abstract class PartsLinkAccessAdapter {
  abstract startPartsLinkAccess (
    request: PartsLinkAccessRequest
  ): Observable<void>
}
